<template>
  <div>
    <transition
      name="fade"
      @after-leave="afterLeave"
    >
      <div v-if="show">
        <b-alert
          variant="danger"
          :show="procede === false"
        >
          <h4 class="alert-heading">
            Algo ha ocurrido
          </h4>
          <div class="alert-body">
            <span>
              Por favor,
              <br>- <b> Verifique que la liga del correo de confirmación coincida con la ingresada en el navegador. </b>
              <br>- También puede que <b>ya haya realizado este paso.</b> Si perdiste tu usuario y contraseña, recuperalas con soporte.
              <br>- Si el error continúa pónganse en contacto con nosotros.
            </span>
          </div>
        </b-alert>
        <template v-if="procede === true">
          <b-row>
            <b-col />
            <b-col lg="6">
              <b-overlay
                :show="loader"
                opacity="0.50"
                rounded="sm"
              >
                <!-- IF WE DON'T HAVE ERROR -->
                <b-card>
                  <!-- TÍTULO DE CARD, NOMBRE DE EVENTO Y ICON -->
                  <titleSection
                    title="Creación de usuario para el acceso a la plataforma"
                    icon="KeyIcon"
                  />

                  <div
                    v-if="personaData"
                    class="text-justify mx-2 mt-2"
                  >
                    <strong class="text-primary"> Hola
                      {{ personaData.nombre }}
                      {{ personaData.segundoNombre }}
                      {{ personaData.apellidoPaterno }}
                      {{ personaData.apellidoMaterno }}
                    </strong>
                    <p>
                      <small>
                        <b>Estas apunto de entrar al Campus Virtual Indetec, porfavor crea tu usuario y contraseña.</b></small>
                    </p>
                    <p><small>
                      Por seguridad, este formulario caduca en 30 minutos, le pedimos de la manera más atenta que complete los campos durante este intervalo de tiempo.
                    </small></p>
                    <p><small>
                      Si el formulario se caduca, no se preocupe, vuelva a presionar el enlace que se encuentra en su bandeja de correo electrónico.
                    </small></p>
                  </div>
                  <validation-observer ref="simpleRules">
                    <b-form>
                      <b-row class="mt-2">

                        <!-- usuario -->
                        <b-col cols="12">
                          <b-form-group
                            label="Usuario"
                            label-for="usuario"
                          >
                            <validation-provider
                              #default="{ errors }"
                              name="Usuario"
                              rules="required|min:5|max:45|usuariocaracteres"
                            >
                              <b-form-input
                                id="usuario"
                                v-model="formulario.usuario"
                                :state="errors.length > 0 ? false:null"
                                placeholder="Usuario"
                                autocomplete="off"
                                onkeyup="javascript:this.value=this.value.toLowerCase();"
                              />
                              <small class="text-danger">Importante:</small>
                              <br>
                              <small>* Su usuario debe contener solo letras minúsculas y/o números, asegúrese agregar por lo menos una letra, de lo contrario generará un error.</small>
                              <br>
                              <small>* Le recomendamos anotar en alguna libreta su usuario y contraseña.</small>
                              <br>
                              <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                          </b-form-group>
                        </b-col>
                      </b-row>
                      <b-row class="mt-2">
                        <b-col
                          lg="5"
                          md="5"
                          sm="12"
                        >
                          <b-form-group
                            label="Contraseña"
                            label-for="password"
                          >
                            <validation-provider
                              #default="{ errors }"
                              name="contraseña"
                              rules="required|password|max:25"
                            >
                              <b-form-input
                                id="password"
                                v-model="formulario.contrasena"
                                :type="passwordFieldType"
                                placeholder="Contraseña"
                                :state="errors.length > 0 ? false:null"
                                autocomplete="off"
                              />
                              <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                          </b-form-group>
                        </b-col>
                        <!-- confirm password -->
                        <b-col
                          lg="5"
                          md="5"
                          sm="12"
                        >
                          <b-form-group
                            label="Confirmar Contraseña"
                            label-for="ac-password"
                          >
                            <validation-provider
                              #default="{ errors }"
                              name="confirmar contraseña"
                              rules="required|confirmed:contraseña"
                            >
                              <b-form-input
                                id="ac-password"
                                v-model="formulario.confirmacion_contrasena"
                                :type="passwordFieldType"
                                placeholder="Confirmar contraseña"
                                :state="errors.length > 0 ? false:null"
                                autocomplete="off"
                              />
                              <small class="text-danger">{{ errors[0] }}</small>
                            </validation-provider>
                          </b-form-group>
                        </b-col>
                        <b-col
                          lg="2"
                          md="2"
                          sm="12"
                          class="text-center"
                        >
                          <b-form-group>
                            <br>
                            <b-button
                              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                              variant="primary"
                              size="lg"
                              class="btn-icon rounded-circle"
                              @click="togglePasswordVisibility()"
                            >
                              <feather-icon
                                :icon="passwordToggleIcon"
                                class="cursor-pointer btn-icon rounded-circle"
                              />
                            </b-button>
                          </b-form-group>
                        </b-col>
                      </b-row>
                      <!-- login button -->
                      <b-row class="mt-2">
                        <b-col md="12">
                          <b-button
                            variant="primary"
                            block
                            @click.prevent="validationForm"
                          > Crear
                          </b-button>
                        </b-col>
                      </b-row>
                    </b-form>
                  </validation-observer>
                </b-card>
              </b-overlay>
            </b-col>
            <b-col />
          </b-row>
        </template>
      </div>
    </transition>
    <transition
      name="enter"
    >
      <div v-if="show2">
        <b-row align-v="baseline">
          <b-col
            md="9"
            lg="9"
          >
            <b-card>
              <div>
                <b-embed
                  v-if="(video.url != '')"
                  type="iframe"
                  aspect="16by9"
                  :src="video.url"
                  allowfullscreen
                />
                <b-alert
                  variant="primary"
                  class="mt-1"
                  show
                >
                  <div class="alert-body">
                    Si no puede escuchar el audio del vídeo, puede subir del volúmen desde la configuración del mismo.
                    <p> Este video lo puedes encontrar dentro de tu cuenta Campus Virtual, en la sección de: "Videos Tutoriales" </p>
                  </div>
                </b-alert>
              </div>
            </b-card>
          </b-col>
          <b-col
            md="2"
            lg="2"
            class="m-1"
          >
            <b-button
              variant="primary"
              block
              @click.prevent="redireccionarlogin()"
            > Entrar a Mi Cueta Campus Virtual
            </b-button>
          </b-col>
        </b-row>
      </div>
    </transition>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import {
  BAlert,
  BFormInput,
  BFormGroup, BForm, BRow, BCol, BButton, BCard, BOverlay, BEmbed,
} from 'bootstrap-vue'
import hostname from '@core/utils/http/config-hostname'
import { required, password } from '@validations'
import titleSection from '@/views/components/title-section.vue'
import Ripple from 'vue-ripple-directive'
import { getTblNla, getData, postData } from '@core/utils/http/general'
// import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import {
  onMounted, ref, getCurrentInstance, computed,
} from '@vue/composition-api'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { useRouter } from '@core/utils/utils'
import router from '@/router'

let interval // INTERVALO PARA HACER REDIRECT DESPUÉS DE 45MIN SIN HACER SUBMIT

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BFormGroup,
    BForm,
    BButton,
    BOverlay,
    ValidationProvider,
    ValidationObserver,
    titleSection,
    BAlert,
    BEmbed,
  },
  directives: {
    Ripple,
  },
  // mixins: [togglePasswordVisibility],
  data() {
    return {
      // VALIDATIONS
      required,
      password,
      // EXTRA
    }
  },
  setup() {
    const { route } = useRouter()
    const toast = useToast()
    const personaData = ref(null)
    const procede = ref(true)
    const loader = ref(false)
    const errorPage = ref(false)
    const passwordFieldType = ref('password')
    let oldTbl = ''
    let tbl = ''
    let nla = ''
    const show2 = ref(false)
    const show = ref(true)
    const simpleRules = ref(null)
    let preRegistro = null
    let timestamp = null
    let counter = 1
    const vm = getCurrentInstance().proxy
    const { t } = route.value.query // * pre-register ID
    const video = ref({ url: '' })
    const passwordToggleIcon = computed(() => (passwordFieldType.value === 'password' ? 'EyeOffIcon' : 'EyeIcon'))
    const togglePasswordVisibility = () => { passwordFieldType.value = passwordFieldType.value === 'password' ? 'text' : 'password' }

    // FORM
    const formulario = ref({
      usuario: '',
      contrasena: '',
      confirmacion_contrasena: '',
      id: '',
      date: null,
    })

    extend('usuariocaracteres', {
      message:
    'El {_field_} no admite espacios, acentos ni la letra ñ, escriba por lo menos una letra',
      validate: value => {
        const cuponvalido = new RegExp(/^(?=.*[a-z])[a-z\d]+$/g)
        return cuponvalido.test(value)
      },
    })

    const intervalRedirect = () => {
      interval = setInterval(() => {
        if (tbl === oldTbl) {
          toast({
            component: ToastificationContent,
            props: {
              title: 'Formulario caducado',
              text: 'El formulario de credeniales ha expirado, ingrese nuevamente',
              icon: 'AlertCircleIcon',
              variant: 'warning',
            },
          },
          { timeout: 8000 })

          clearInterval(interval)
          router.push('/')
        }
        oldTbl = tbl
      }, 2700000)
    }

    // eslint-disable-next-line camelcase
    const promise_tbl_nla = () => {
      const promesa = new Promise((resolve, reject) => {
        loader.value = true
        getTblNla()
          .then(response => {
            if (response.status === 200 && response.data.status === 200) {
              tbl = response.data.data.tbl
              nla = response.data.data.nla
              resolve()
            } else reject(response.data.message)
          })
          .catch(err => reject(err))
      })
      promesa
        .then(() => {
          oldTbl = tbl
          intervalRedirect()
        })
        .catch(error => {
          errorPage.value = true
          toast({
            component: ToastificationContent,
            props: {
              title: 'Error en solicitud [tbl/nla]',
              text: error,
              icon: 'AlertCircleIcon',
              variant: 'danger',
            },
          },
          { timeout: 8000 })
        })
        .finally(() => loader.value)
    }

    const afterLeave = () => {
      show2.value = true
    }

    const clearForm = () => {
      formulario.value.usuario = ''
      formulario.value.contrasena = ''
      formulario.value.confirmacion_contrasena = ''
      formulario.value.id = ''
      formulario.value.date = null
    }

    const registroExitoso = () => {
      if (!t) {
        vm.$swal({
          title: '<b>Credenciales creadas</b>',
          html: 'Listo, ya cuentas con un usuario y contaseña para entrar a la plataforma; <b> Tenemos un video de inducción para ti ¡Bienvenido!',
          icon: 'success',
          timer: 10000,
          showConfirmButton: true,
          buttonsStyling: false,
          confirmButtonText: 'Muy bien, veré el video de inducción y posteriormente daré click en "Entrar a mi cuenta Campus Virtual"',
          customClass: {
            confirmButton: 'btn btn-primary',
          },
        // eslint-disable-next-line no-unused-vars
        }).then(() => {
          show.value = false
        })
      } else {
        vm.$swal({
          title: '<b>Credenciales creadas</b>',
          html: 'Listo, ya puede cerrar esta ventana',
          icon: 'success',
          timer: 10000,
          showConfirmButton: true,
          buttonsStyling: false,
          confirmButtonText: 'ok',
          customClass: {
            confirmButton: 'btn btn-primary',
          },
        })
      }
      clearForm()
    }

    const redireccionarlogin = () => {
      window.location.href = `${hostname().host}/${process.env.VUE_APP_SERVICE_INGRESO}`
    }

    const submitForm = () => {
      if (counter <= 20) {
        loader.value = true
        const params = new FormData()
        formulario.value.id = preRegistro
        formulario.value.date = timestamp
        params.append('task', 'wspublico')
        params.append('origin', process.env.VUE_APP_ORIGIN_API)
        params.append('action', 14)
        params.append('tbl', tbl)
        params.append('nla', nla)
        params.append('data', JSON.stringify(formulario.value))
        if (t) params.append('t', t)
        postData(params)
          .then(response => {
            if (response.status === 200 && response.data.status === 200) {
              registroExitoso()
            } else {
              toast({
                component: ToastificationContent,
                props: {
                  title: `${response.data.status} - Atención`,
                  text: response.data.message,
                  icon: 'AlertCircleIcon',
                  variant: `${response.data.status === 500 ? 'danger' : 'warning'}`,
                },
              },
              { timeout: 8000 })
              tbl = response.data.tbl
            }
          })
          .catch(err => {
            // this.promise_tbl_nla() // MAKE PROMISE TO TBL REQUEST
            toast({
              component: ToastificationContent,
              props: {
                title: 'Error en solicitud [submit]',
                text: err,
                icon: 'AlertCircleIcon',
                variant: 'danger',
              },
            },
            { timeout: 8000 })
          })
          .finally(() => { loader.value = false })
        counter += 1
      } else {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Exceso de intentos',
            text: 'La página ha expirado, por favor, intente nuevamente más tarde',
            icon: 'AlertCircleIcon',
            variant: 'danger',
          },
        },
        { timeout: 8000 })
      }
    }

    const validationForm = () => {
      simpleRules.value.validate().then(success => {
        if (success) {
          submitForm()
        }
      })
    }

    const videoIntroductorio = () => {
      getData({ action: 7 }, 'wspagepublic')
        .then(response => {
          if (response.status === 200 || response.data.status === 200) { [video.value] = response.data.data }
        })
    }
    //* On mounted
    onMounted(() => {
      videoIntroductorio()
      const promesa = new Promise((resolve, reject) => {
        const datos = { tkn: route.value.params.id, date: route.value.params.time }
        getData({ action: 19, dato: datos })
          .then(response => {
            if (response.status === 200 && response.data.status === 200) resolve(true)
            else {
              // eslint-disable-next-line prefer-promise-reject-errors
              reject(`Url no valida - Disculpe las molestias ${response.data.message}`)
            }
          })
          .catch(error => reject(error))
      })
      const promesa2 = new Promise((resolve, reject) => {
        const datos = { tkn: route.value.params.id, date: route.value.params.time, t }
        getData({ action: 29, dato: datos })
          .then(response => {
            if (response.status === 200 && response.data.status === 200) {
            // eslint-disable-next-line prefer-destructuring
              resolve(response.data)
            } else {
              procede.value = false
              // eslint-disable-next-line prefer-promise-reject-errors
              reject(`Disculpe las molestias - ${response.data.message}`)
            }
          }).catch(error => reject(error))
      })

      loader.value = true
      Promise.all([promesa, promesa2])
        .then(respuestas => {
          const [resValidacion, resPromesa2] = respuestas
          if (resValidacion) procede.value = true

          // eslint-disable-next-line prefer-destructuring
          personaData.value = resPromesa2.data[0]

          if (resPromesa2.c) {
            formulario.value.usuario = resPromesa2.c.usuario
            formulario.value.contrasena = resPromesa2.c.contrasena
            formulario.value.confirmacion_contrasena = resPromesa2.c.contrasena
            passwordFieldType.value = 'text'
          }
        }).catch(error => {
          procede.value = false
          toast({
            component: ToastificationContent,
            props: {
              title: 'Error en petición',
              text: error,
              icon: 'AlertCircleIcon',
              variant: 'danger',
            },
          },
          { timeout: 8000 })
        })
        .finally(() => { loader.value = false })
      preRegistro = route.value.params.id
      timestamp = route.value.params.time
      promise_tbl_nla() // MAKE PROMISE TO TBL REQUEST
    })

    return {
      // variables
      personaData,
      procede,
      loader,
      errorPage,
      formulario,
      show,
      show2,
      simpleRules,
      passwordFieldType,
      video,
      // computadas
      passwordToggleIcon,
      togglePasswordVisibility,
      // funciones
      validationForm,
      afterLeave,
      redireccionarlogin,
    }
  },

}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-sweetalert.scss';
.fade-enter-active, .fade-leave-active {
  transition : opacity 1s
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0
}
.fade-enter-active, .fade-leave-active {
  transition: opacity 1s
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0
}
.fade-enter-active, .fade-leave-active {
  transition: opacity 1s
}
</style>
